import { render, staticRenderFns } from "./EmptyBoard.vue?vue&type=template&id=7171b56c"
import script from "./EmptyBoard.vue?vue&type=script&lang=js"
export * from "./EmptyBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports